import React from "react";
import Link from "gatsby-link";
import FullLogoOnWhite from "./full-logo-on-white.svg";
import StripeCheckout from "react-stripe-checkout";
import { withPrefix } from "gatsby-link";

export default () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Lead");
  }
  return (
    <div className="container">
      <header>
        <h1>Sign up for Quiver</h1>
      </header>
      <iframe
        src="https://dashboard.graphql-quiver.com/signup"
        frameborder="0"
        id="signup-iframe"
        data-form-source="https://dashboard.graphql-quiver.com/signup"
        class="iframe-form "
        data-pass-through-params="code next platform trial plan period referrer"
      />
      <style jsx>{`
        iframe {
          border: none;
          width: 100%;
          height: 600px;
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/signup.js